module.exports = __webpack_public_path__ + "static/img/bg-ar.bb3ab8fe.png";